import { render, staticRenderFns } from "./SmartOrderDetail.vue?vue&type=template&id=5c422dd6&scoped=true&"
import script from "./SmartOrderDetail.vue?vue&type=script&lang=js&"
export * from "./SmartOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./SmartOrderDetail.vue?vue&type=style&index=0&id=5c422dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c422dd6",
  null
  
)

export default component.exports